class ConfigurationProvider {
  constructor(config = {}) {
    this.config = config
  }

  getConfig() {
    return this.config
  }

  setConfig(newConfig) {
    this.config = { ...this.config, ...newConfig }
  }
}
let instance = null;
function getInstance() {
  if (!instance) {
    instance = new ConfigurationProvider()
  }
  return instance
}

export default getInstance()
